
import Header from '../../../Commons/Headers/Header'
import Footer from '../../../Commons/Footer'
import HeroSection from './HeroSection'
import BenefitsSection from './BenefitSection'
import HowItWorks from './HowItWorks'
import CTASection from './CTA'
import ProtectionSection from './ItemsProtection'
import WhatCanYouLend from './WhatCanYouLend'
import SuccessStories from './SuccessStories'



function LenderLandingPage() {
  return (
    <>
      <Header />

      <HeroSection />
      <BenefitsSection />
      <HowItWorks />
      <WhatCanYouLend />
      <SuccessStories />
      <ProtectionSection />
      <CTASection />

      <Footer />
    </>
  )
}

export default LenderLandingPage

